/* @flow */

'use strict';

/*:: import type {PluginConfig, PluginResult} from '.';*/

var Prefixer = require('../prefixer');

var prefixPlugin = function prefixPlugin(_ref /*: PluginConfig*/) /*: PluginResult*/ {
  var componentName = _ref.componentName;
  var style = _ref.style;

  var newStyle = Prefixer.getPrefixedStyle(componentName, style);
  return { style: newStyle };
};

module.exports = prefixPlugin;


//////////////////
// WEBPACK FOOTER
// ./~/@jimpick/spectacle/~/radium/lib/plugins/prefix-plugin.js
// module id = 941
// module chunks = 2